import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import "./css/OurStarStudent.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const OurStarStudent = () => {
  return (
    <div style={{ width: "100%" }}>
      <div
        className=""
        style={{
          // paddingLeft: "10px",
          // paddingRight: "10px",
          // paddingTop: "20px",
          // paddingBottom: "80px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          className="row"
          style={{
            height: "100%",
            width: "80%",
            padding: "20px",
            boxShadow: "0px 2px 20px #bebebe",
            display: "flex",
            gap: "20px",
            borderRadius: "20px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <h2 className="title-about">Meet our Star Student</h2>
          {/* Left: Trainer Photo */}
          <div
            className="col-sm-12 col-md-4"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src="./Students/Rajveer-2.png" // Replace with actual path to Ishan's photo
              alt="Ishan Agarwal"
              style={{
                width: "200px",
                height: "200px",
                borderRadius: "50%",
                objectFit: "cover",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
              }}
            />
          </div>

          {/* Right: Trainer Info */}
          <div className="col-sm-12 col-md-7 about-para">
            <p>
              <b>Name:</b> Rajveer Singh
            </p>
            <p>
              <b>City:</b> Akbarpur, Ambedkar Nagar, UP
            </p>
            <p>
              <b>Startup Name:</b> JustGoCartt ( Quick Commerce for small towns
              and remote areas )
            </p>
            {/* <div>
              <b>Hear it from himself:</b>
              <p>
                I joined Course A – Career Decision Year-long Workshop by
                YAPASSIO when I was in Class 10. That program not only gave me
                clarity about my strengths and career choices but also built my
                confidence to take bold decisions early in life. With the right
                mentorship and exposure from YAPASSIO, I chose Commerce in Class
                11 and started exploring entrepreneurship. Today, in Class 12, I
                have successfully launched my own startup named Justgorcartt, a
                quick commerce platform designed for smaller towns. The
                continuous guidance, mentorship, and real-world learning I
                received from YAPASSIO played a huge role in shaping my journey
                from a student to a founder.
              </p>
            </div> */}
            <Accordion
              className="custom-accordion"
              style={{ marginTop: "20px" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <p className="accordion-heading">Hear it from himself</p>
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Enrolling in YAPASSIO’s 'Career Decision Year-long Workshop'
                  during my 10th grade was a turning point. The program provided
                  the mentorship and clarity I needed to confidently pursue
                  Commerce in 11th grade and begin my entrepreneurial journey.
                  By leveraging the exposure and guidance provided by YAPASSIO,
                  I have now launched Justgorcartt—a quick-commerce startup
                  tailored for smaller towns—while still in 12th grade. YAPASSIO
                  was instrumental in bridging the gap between being a student
                  and a founder.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStarStudent;
